/* eslint-disable react/require-default-props */
// @ts-nocheck
import React, { useEffect, useState } from "react";
import { AppBar, Grid, makeStyles, SwipeableDrawer, Toolbar, Typography, List, ListItemIcon, ListItemText, ListItem, Hidden, useMediaQuery, } from "@material-ui/core";
import StoreIcon from "@dev-togetherprice/icons.store";
import ProfileIcon from "@dev-togetherprice/icons.user";
import TrustIcon from "@dev-togetherprice/icons.trust";
import WalletIcon from "@dev-togetherprice/icons.wallet";
import InviteIcon from "@dev-togetherprice/icons.invite";
import SupportIcon from "@dev-togetherprice/icons.support";
import SettingsIcon from "@dev-togetherprice/icons.settings";
import LogoutIcon from "@dev-togetherprice/icons.logout";
import GlobeIcon from "@dev-togetherprice/icons.globe";
import LayersIcon from "@dev-togetherprice/icons.layers";
import AddIcon from "@dev-togetherprice/icons.add";
import GroupIcon from "@dev-togetherprice/icons.group";
import MenuIcon from "@dev-togetherprice/icons.menu";
import IconButton from "@dev-togetherprice/components.icon-button";
import { useUserRiskManagement } from "@dev-togetherprice/api.settings";
import { updateFunnel, useConfigurations } from "@dev-togetherprice/api.user";
import useRegisteredTranslation from "@dev-togetherprice/hooks.use-register-translation";
import AbTest, { Experiment, useVariant } from "@dev-togetherprice/components.ab-test";
import theme from "@dev-togetherprice/theme";
import { useRouteMatch } from "react-router-dom";
import { useSWRConfig } from "swr";
import en from "./i18n/en.json";
import it from "./i18n/it.json";
import es from "./i18n/es.json";
import pt from "./i18n/pt.json";
const TRANSLATIONS = { en, es, it, pt };
const useStyles = makeStyles((theme) => ({
    root: {
        top: "auto",
        bottom: 0,
        borderTopLeftRadius: theme.spacing(4),
        borderTopRightRadius: theme.spacing(4),
        backgroundColor: theme.palette.common.white,
        paddingBottom: "env(safe-area-inset-bottom)",
    },
    item: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    toolbar: {
        alignItems: "stretch",
    },
    container: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    button: {
        height: "100%",
        padding: theme.spacing(1),
    },
    buttonLabel: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        transform: "translateY(2px)",
        "& svg": {
            fontSize: "20px",
        },
    },
    buttonIconLabel: {
        fontSize: "12px",
        width: "100%",
        textAlign: "center",
    },
}));
const useMenuStyles = makeStyles((theme) => ({
    root: {},
    paper: {
        borderTopLeftRadius: theme.spacing(10),
        borderTopRightRadius: theme.spacing(10),
        padding: theme.spacing(5, 6.5),
        paddingTop: theme.spacing(2),
    },
    drag: {
        height: 4,
        width: 60,
        borderRadius: 10,
        backgroundColor: theme.palette.grey[300],
        marginBottom: theme.spacing(1),
    },
    list: {
        width: "100%",
        padding: 0,
    },
    item: {
        padding: theme.spacing(2),
    },
    icon: {
        minWidth: 40,
    },
    text: {
        margin: 0,
        "& span": {
            fontWeight: 500,
            color: theme.palette.grey[700],
            fontSize: 16,
            textAlign: "left",
        },
    },
}));
const Menu = ({ open, setOpen, navigateToUrl, t }) => {
    const classes = useMenuStyles();
    const variant = useVariant();
    const { mutate } = useSWRConfig();
    const { data } = useConfigurations();
    const isReferralEnabled = !!JSON.parse(data['frontEnd.referral.enabled']);
    const items = [
        variant !== "A" && {
            title: "MenuBar.store",
            icon: React.createElement(StoreIcon, null),
            page: "/store",
            funnel: "click_store_menu",
        },
        {
            title: "MenuBar.profile",
            icon: React.createElement(ProfileIcon, null),
            page: "/account/profile",
        },
        { title: "MenuBar.trust", icon: React.createElement(TrustIcon, null), page: "/account/trust" },
        { title: "MenuBar.wallet", icon: React.createElement(WalletIcon, null), page: "/account/wallet" },
        isReferralEnabled && {
            title: "MenuBar.invite",
            icon: React.createElement(InviteIcon, null),
            page: "/referral",
        },
        { title: "MenuBar.support", icon: React.createElement(SupportIcon, null), page: "/faqs" },
        {
            title: "MenuBar.settings",
            icon: React.createElement(SettingsIcon, null),
            page: "/account/settings",
        },
        { title: "MenuBar.logout", icon: React.createElement(LogoutIcon, null), page: "/logout" },
    ].filter(Boolean);
    useEffect(() => {
        if (open) {
            // fetch AB Test to show updated values
            mutate("preloadExperiments");
        }
    }, [open]);
    return (React.createElement(SwipeableDrawer, { anchor: "bottom", open: open, onClose: () => {
            setOpen(false);
        }, onOpen: () => setOpen(true), classes: { paper: classes.paper }, disableSwipeToOpen: true },
        React.createElement(Grid, { xs: 12, container: true, item: true, direction: "column", alignItems: "center" },
            React.createElement("div", { className: classes.drag }),
            React.createElement(List, { className: classes.list }, items.map(({ title, icon, page, funnel }) => {
                const prefix = title.split(" ").join("_");
                return (React.createElement(ListItem, { key: `${prefix}_item`, className: classes.item, onClick: () => {
                        setOpen(false);
                        if (funnel) {
                            updateFunnel({ column: funnel });
                        }
                        if (page) {
                            navigateToUrl(page);
                        }
                    }, disableGutters: true, button: true },
                    React.createElement(ListItemIcon, { key: `${prefix}_item_icon`, className: classes.icon }, icon),
                    React.createElement(ListItemText, { key: `${prefix}_item_text`, className: classes.text }, t(title))));
            })))));
};
const MenuItem = ({ label, children, active = false, onClick, }) => {
    const classes = useStyles();
    return (React.createElement(IconButton, { shape: "rounded", variant: "default", color: active ? "primary" : "default", classes: {
            root: classes.button,
            label: classes.buttonLabel,
        }, onClick: onClick },
        children,
        React.createElement(Typography, { component: "span", className: classes.buttonIconLabel, display: "block" }, label)));
};
const NavBar = ({ navigateToUrl, onCannotCreatePost, }) => {
    var _a;
    const canCreatePost = (_a = useUserRiskManagement().createNewGroup) !== null && _a !== void 0 ? _a : true;
    const classes = useStyles();
    const [menuOpen, setMenuOpen] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { t } = useRegisteredTranslation("Navbar", TRANSLATIONS);
    const isGroups = !!useRouteMatch({
        path: "/sharings",
    });
    const isSocial = !!useRouteMatch({
        path: "/social",
    });
    const isHome = !!useRouteMatch({
        path: ["/home"],
    });
    const isExactHome = !!useRouteMatch({
        path: "/",
        exact: true,
    });
    return (React.createElement(Hidden, { mdUp: true },
        React.createElement(AppBar, { position: "fixed", className: classes.root },
            React.createElement(Toolbar, { className: classes.toolbar },
                React.createElement(Grid, { container: true, direction: "row", justifyContent: "space-between", alignItems: "stretch", className: classes.container },
                    React.createElement(Grid, { item: true, className: classes.item },
                        React.createElement(MenuItem, { active: isHome || isExactHome, label: t("network"), onClick: () => navigateToUrl(isMobile ? "/v2/" : "/home") },
                            React.createElement(GlobeIcon, null))),
                    React.createElement(Grid, { item: true, className: classes.item },
                        React.createElement(MenuItem, { active: isGroups, label: t("groups"), onClick: () => navigateToUrl("/sharings/pending") },
                            React.createElement(LayersIcon, null))),
                    React.createElement(Grid, { item: true, className: classes.item },
                        React.createElement(IconButton, { shape: "rounded", variant: "contained", color: "secondary", onClick: canCreatePost
                                ? () => navigateToUrl("/create")
                                : onCannotCreatePost },
                            React.createElement(AddIcon, null))),
                    React.createElement(Grid, { item: true, className: classes.item },
                        React.createElement(MenuItem, { active: isSocial, label: t("social"), onClick: () => navigateToUrl("/social") },
                            React.createElement(GroupIcon, null))),
                    React.createElement(Grid, { item: true, className: classes.item },
                        React.createElement(MenuItem, { label: t("menu"), onClick: () => setMenuOpen(true) },
                            React.createElement(MenuIcon, null)))))),
        React.createElement(AbTest, null,
            React.createElement(Experiment, { name: "TP_STORE", defaultVariant: "A", swrConfig: { revalidateOnFocus: true } },
                React.createElement(Menu, { open: menuOpen, setOpen: setMenuOpen, navigateToUrl: navigateToUrl, t: t })))));
};
export default NavBar;
